export default "/images/vendor/flag-icon-css/flags/4x3/am.svg?e935f82147f4d3c76c9284797c6f2a20";